import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

class TermAndCondition extends Component {

  constructor(props){
    super(props);

    this.state = {
      accept : false,
      next : ''
    }

    this.next = this.next.bind(this);

  }

  componentDidMount(){
    if(this.props.location.token === undefined){
      this.setState({next: 'login'});
    }
  }

  next(){
    this.setState({ next : 'createPassword'});
  }

  _renderNextButton(){

    if(this.state.accept){
      return(
        <button onClick={this.next}
          style={{height: 35,width:77, borderRadius: 4,color: 'white',background: "linear-gradient(#41b9ce, #58488b)"}}>
          NEXT
        </button>
      );
    }else{
      return(
        <button
          style={{height: 35,width:77, borderRadius: 4,color: 'white',background: "rgb(150, 150 ,150)"}}>
          NEXT
        </button>
      );
    }
  }

  render() {

    if( this.state.next === 'createPassword'){
      return <Redirect to={{pathname: "/createPassword" ,token: this.props.location.token}} />
    }else if(this.state.next === 'login' ){
      return <Redirect to='/login'/>
    }

    return(
      <div className='container' style={{backgroundColor: 'rgb(220, 224, 239)'}}>
        <div style={{height:80}}>
        </div>
        <div className="row">
          <div className="col-md-10 col-md-offset-1" style={{overflow: 'hidden',backgroundColor: 'white' , textAlign:'center' , borderRadius: 5,paddingLeft: 0 , paddingRight:0 }}>

            <div style={{ padding: 15,backgroundColor: 'rgb(68 ,53 ,109)' ,height:60}}>
              <font style={{color:'white',textAlign: 'center'}}><h4>ข้อตกลงในการใช้งาน</h4></font>
            </div>

            <div style={{height:30}}/>

            <img src={require('../assets/img/logo.png')}
              style={{width:246 ,height:75}}
              alt="term and condition"/>

            <div style={{height:32}} />

            <iframe src={"https://genode-web.widelyapps.net/terms-app/"}
              title={"term and condition"}
              className="col-md-10 col-md-offset-1" style={{marginBottom: 40, height:1206 }}
              />

          </div>
        </div>

        <div style={{textAlign:'center'}}>
          <div style={{height: 28}} />

          <input type="checkbox"
            value={this.state.accept}
            onChange={() => {this.setState({ accept : !this.state.accept})}}/> <h4 style={{display:'inline-block'}}>ยอมรับเงื่อนไขการใช้บริการ</h4>

          <div style={{height:11}} />

          {this._renderNextButton()}

          <div style={{height: 28}} />

        </div>
      </div>
    );
  }
}

export default TermAndCondition;



// WEBPACK FOOTER //
// ./src/components/TermAndCondition.js